import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "video-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1)
const _hoisted_3 = { class: "video" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vueVimeoPlayer = _resolveComponent("vueVimeoPlayer")!

  return (_ctx.status)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeVideo && _ctx.closeVideo(...args)), ["prevent"])),
          class: "close"
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_vueVimeoPlayer, {
            ref: "player",
            "video-id": _ctx.id,
            "player-width": _ctx.videoWidth,
            "player-height": _ctx.videoHeight
          }, null, 8, ["video-id", "player-width", "player-height"])
        ])
      ]))
    : _createCommentVNode("", true)
}